export default "__VITE_ASSET__CT3m6ypp__"